import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    container: 'container',
    base: 'flex items-end justify-between gap-5 pt-5 pb-10 max-lg:flex-col max-lg:items-start max-md:pb-5',
    title: 'w-[322px] gap-4 max-lg:flex max-lg:w-full max-lg:items-center',
    titleBlog:
      'font-cormorant-garamond text-yellow-naos text-[48px] leading-none font-bold lowercase italic max-lg:mt-4',
    aboutSkin:
      'text-main text-[80px] leading-none font-semibold whitespace-nowrap uppercase max-md:text-[64px]',
    nav: 'heading-3xl text-secondary-hover max-xl:heading-2xl max-md:heading-m max-xs:gap-1.5 flex items-center gap-4 font-light max-md:gap-2',
    navItem: 'hover:text-main transition-all'
  },
  variants: {
    active: {
      true: {
        navItem: 'text-main font-semibold'
      }
    }
  }
});
